import React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";

import letterIllustration from "../../../public/static/images/demo/illustration.png";
import { useTranslation } from "next-i18next";
import Container from "../../Common/Container";
import CloudinaryImage from "../../Common/CloudinaryImage";
import PipeDriveForm from "../../Common/PipedriveForm/PipedriveForm";

export default function Form() {
  const theme = useTheme();
  const { t } = useTranslation("partnerships");
  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  return (
    <Box bgcolor={theme.palette.alternate.dark} id="form">
      <Container>
        <Grid container spacing={isMd ? 8 : 4}>
          <Grid item xs={12} md={6}>
            <Typography
              variant="h2"
              component={"h3"}
              mb={2}
              sx={{
                fontWeight: 700,
              }}
            >
              {t("form.title")}
            </Typography>
            <Box
              width={458}
              height={274}
              sx={{ marginTop: 3, marginX: "auto" }}
            >
              <CloudinaryImage
                src={letterIllustration}
                alt="Illustration letter"
                width={458}
                height={274}
                placeholder="blur"
              />
            </Box>
          </Grid>
          <Grid item container xs={12} md={6} alignItems={"center"}>
            <Box
              padding={{ xs: 3, sm: 6 }}
              width={"100%"}
              component={Card}
              borderRadius={2}
              boxShadow={4}
              marginBottom={4}
            >
              <PipeDriveForm formId={t("form.pipedrive_form_id")}/>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
